module.exports = new Promise((resolve, reject) => {
		window["_paperco_mfe_resolver_instant-feedback-web"] = { resolve, reject };
		const script = document.createElement("script");
		script.type = "module";
		script.async = true;
		script.innerHTML = `
			import("https://instant-feedback-web.paperstg.co/assets/remoteEntry.mjs")
				.then(remoteEntry => window["_paperco_mfe_resolver_instant-feedback-web"].resolve(remoteEntry))
				.catch(() => window["_paperco_mfe_resolver_instant-feedback-web"].reject("Failed to import _paperco_mfe_resolver_instant-feedback-web"));
		`
		document.head.appendChild(script);
	});